import { categories, OTHER_CATEGORY } from '../apps/categories'

export function groupAppsByCategory(appsObj) {
  const groups = {}

  Object.entries(appsObj).forEach(([key, app]) => {
    // Some apps are already reachable another way (e.g. adminTools/profile
    // via the header's own menu buttons) and would just be duplicated here.
    if (app.hideFromHomeGrid) return

    const catKey = app.category && categories[app.category] ? app.category : OTHER_CATEGORY.key
    const catMeta = categories[catKey] || OTHER_CATEGORY

    if (!groups[catKey]) {
      groups[catKey] = { key: catKey, label: catMeta.label, order: catMeta.order, apps: [] }
    }
    groups[catKey].apps.push([key, app])
  })

  Object.values(groups).forEach(group => {
    group.apps.sort(([, a], [, b]) => a.displayName.localeCompare(b.displayName, 'sv'))
  })

  return Object.values(groups).sort((a, b) => a.order - b.order)
}
